class TrCountryText extends HTMLElement {
	selectors = {
		text: '[data-tr-js-country-text]'
	};

	attributes = {
		countryCode: 'country-code',
		replacementText: 'replacement-text'
	};

	stateClasses = {};

	abortController = null;

	connectedCallback() {
		this.textElement = this.querySelector(this.selectors.text);
		this.countryCode = this.getAttribute(this.attributes.countryCode)?.toUpperCase();
		this.replacementText = this.getAttribute(this.attributes.replacementText);

		this.init();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);

		this.destroy();
	}

	init() {
		if (!this.textElement || !this.countryCode || !this.replacementText) return;

		this.abortController = new AbortController();
		this.updateTextForCountry();
	}

	onSectionLoad = event => {
		if (
			!this.closest(`#${event.detail.sectionId}`) &&
			!this.closest(`#shopify-section-${event.detail.sectionId}`)
		)
			return;

		this.destroy();
		this.init();
	};

	async updateTextForCountry() {
		const rootPath = window.Shopify?.routes?.root;

		if (!rootPath) return;

		try {
			const response = await fetch(
				`${rootPath}browsing_context_suggestions.json?country[enabled]=true`,
				{ signal: this.abortController.signal }
			);

			if (!response.ok) return;

			const data = await response.json();
			const detectedCountryCode = data.detected_values?.country?.handle;

			if (detectedCountryCode !== this.countryCode) return;

			this.textElement.textContent = this.replacementText;
		} catch (error) {
			if (error.name !== 'AbortError') return;
		}
	}

	destroy() {
		this.abortController?.abort();
		this.abortController = null;
	}
}

if (!customElements.get('tr-country-text')) {
	customElements.define('tr-country-text', TrCountryText);
}
